const translation = {
  title: 'Container Instance',
  create: {
    title: 'Create Container Instance',
  },
  overview: {
    home: 'Home',
    workload: 'Workload',
    storage: 'Storage',
    other: 'Other',
    containerInstance: 'Container Instance',
    trainTask: 'Training Task',
    inferenceService: 'Inference Service',
    model: 'Model',
    dataset: 'Dataset',
    image: 'Image',
    disk: 'Disk',
    repository: 'Repository',
    userCenter: 'User Center',
    welcome: 'Welcome to {{name}}',
  },
  userPage: {
    welcomeTitle: 'Hi, welcome to {{name}} machine learning platform',
    description: 'Machine learning platform is a one-stop AI algorithm development and iteration platform that serves professional algorithm engineers and integrates cloud-native tools + computing power (GPU, CPU cloud servers).',
    containerInstanceList: 'Container Instance List',
    trainingTaskList: 'Training Task List',
    inferenceServiceList: 'Inference Service List',
    moreData: 'More Data',
  },
  form: {
    name: 'Name',
    nameTooltip: 'Unique name for the container instance. Supports Chinese/English characters, numbers and hyphens',
    resourceSelector: 'Resource Selector',
    volumeMounts: 'Volume Mounts',
    image: 'Container Image',
    workingDir: 'Working Directory',
    workingDirTooltip: 'Working directory path when the container starts. Startup commands will be executed in this directory',
    cmd: 'Start Command',
    cmdTooltip: 'System env vars can be referenced as "{{variable_name}}". username: current user, password: random password, resource_id: instance resource ID',
    args: 'Start Arguments',
    argsTooltip: 'Custom startup arguments',
    env: 'Environment Variables',
    ports: 'Port Mapping',
    confirm: 'Confirm',
    cancel: 'Cancel',
    permission: 'Permission',
  },
  detail: {
    title: 'Instance Detail',
    tabs: {
      detail: 'Detail',
      log: 'Log',
      event: 'Event',
      monitor: 'Monitor',
    },
    loginContainer: 'Login Container',
  },
  edit: {
    title: 'Edit Instance',
  },
  volumeMountsEditor: {
    readWrite: 'Read/Write',
    readOnly: 'Read Only',
    mountPathPlaceholder: 'Mount Path',
    modePlaceholder: 'Mode',
  },
  resources: {
    containerInstance: 'Container Instance',
    trainingTask: 'Training Task',
    inferenceService: 'Inference Service',
    dataset: 'Dataset',
    model: 'Model',
    containerImage: 'Container Image',
    storageResource: 'Storage Resource',
    imageRepository: 'Image Repository',
    createContainerInstance: 'Create Container Instance',
    createTrainingTask: 'Create Training Task',
    createInferenceService: 'Create Inference Service',
    createDataset: 'Create Dataset',
    createModel: 'Create Model',
    createContainerImage: 'Create Container Image',
    total: 'Total',
    running: 'Running',
    private: 'Private',
    diskCount: 'Disk Count',
    privateDiskCount: 'Private Disk Count',
  },
  billing: {
    assetAccount: 'Asset Account',
    rechargeRemittance: 'Recharge & Remittance',
    invoice: 'Invoice',
    availableBalance: 'Available Balance:',
    loading: 'Loading...',
    loadingFailed: 'Loading Failed',
    incomeExpenseOverview: 'Income & Expense Overview',
    monthlyIncome: 'Monthly Income',
    monthlyOrderExpenses: 'Monthly Order Expenses',
    myBenefits: 'My Benefits',
    activeCoupons: 'Active Coupons',
    totalCoupons: 'Total Coupons',
    productInformation: 'Product Information',
    viewMore: 'View More',
    informationNotifications: 'Information Notifications',
  },
  currency: {
    CNY: 'CNY',
    USD: 'USD',
  },
  modelManage: {
    title: 'Model Service',
    addModel: 'Create Model',
    createTitle: 'Create Model',
    editTitle: 'Edit Model',
    detailTitle: 'Model Detail',
    searchPlaceholder: 'Search by model name or ID',
    filter: {
      status: 'Status',
      scenario: 'Task Scenario',
      provider: 'Model Provider',
    },
    table: {
      id: 'ID/Name',
      status: 'Status',
      description: 'Description',
      taskScenario: 'Task Scenario',
      modelSize: 'Model Size',
      contextLength: 'Context Length',
      maxGenerationLength: 'Max Generation Length',
      modelProvider: 'Model Provider',
      sortOrder: 'Sort Order',
      createdAt: 'Created At',
      creator: 'Creator',
      action: 'Action',
      detail: 'Detail',
      edit: 'Edit',
      offline: 'Offline',
      online: 'Publish',
      delete: 'Delete',
      onlineStatus: 'Published',
      offlineStatus: 'Unpublished',
    },
    form: {
      name: 'Model Name',
      nameTooltip: 'Unique identifier name for the model',
      nameRequired: 'Please enter model name',
      nameMinLength: 'Model name must be at least 3 characters',
      nameMaxLength: 'Name should not exceed 100 characters',
      namePlaceholder: 'Please enter model name',
      relatedService: 'Related Service',
      relatedServiceRequired: 'Please select related service',
      description: 'Description',
      descriptionTooltip: 'Detailed description of the model',
      descriptionMaxLength: 'Description should not exceed 500 characters',
      descriptionPlaceholder: 'Please enter a brief description for the model. This summary will be displayed on the model square card',
      taskScenario: 'Task Scenario',
      taskScenarioTooltip: 'Task scenario the model is suitable for',
      taskScenarioRequired: 'Please select task scenario',
      taskScenarioPlaceholder: 'Please select task scenario',
      modelSize: 'Model Size',
      modelSizeTooltip: 'Parameter scale of the model',
      modelSizeRequired: 'Please enter model size',
      modelSizePlaceholder: 'e.g., 7b, 63b',
      modelSizeOption: 'Model Size Option',
      modelSizeOptionRequired: 'Please select model size option',
      contextLength: 'Context Length',
      contextLengthTooltip: 'Maximum context token count supported by the model',
      contextLengthRequired: 'Please enter context length',
      contextLengthPlaceholder: 'e.g., 64k, 128k, 256k',
      contextLengthOption: 'Context Length Option',
      contextLengthOptionRequired: 'Please select context length option',
      maxGenerateLength: 'Max Generate Length',
      maxGenerateLengthTooltip: 'Maximum token count for a single generation',
      maxGenerateLengthRequired: 'Please enter max generate length',
      maxGenerateLengthPlaceholder: 'e.g., 64k, 128k, 256k',
      maxGenerationLength: 'Max Generation Length',
      maxGenerationLengthTooltip: 'Maximum token count for a single generation',
      maxGenerationLengthRequired: 'Please enter max generation length',
      maxGenerationLengthPlaceholder: 'e.g., 2048, 4096',
      modelProvider: 'Model Provider',
      modelProviderTooltip: 'Provider or development organization of the model',
      modelProviderRequired: 'Please select model provider',
      modelProviderPlaceholder: 'Please select model provider',
      modelDetails: 'Model Details',
      modelDetailsTooltip: 'Please describe in detail the features, advantages, applicable scenarios, etc. of the model. Supports rich text format',
      modelDetailsRequired: 'Please fill in model details',
      apiReference: 'API Reference',
      apiReferenceTooltip: 'Provide API usage instructions, parameter details, sample code, etc. Supports rich text format',
      sortOrder: 'Sort Order',
      sortOrderRequired: 'Please enter sort order',
      sortOrderPlaceholder: 'e.g., 1, 2, 3',
      customTags: 'Custom Tags',
      addCustomTag: 'Add Custom Tag',
      tagNamePlaceholder: 'Please enter tag name',
      addCustomTagButton: '+ Custom Tag',
      creator: 'Creator',
      creatorTooltip: 'Creator information of the model',
      creatorPlaceholder: 'Please enter creator',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    taskScenarios: {
      textGeneration: 'Text Generation',
      chatbot: 'Chatbot',
      codeGeneration: 'Code Generation',
      translation: 'Translation',
      summarization: 'Summarization',
      questionAnswering: 'Question Answering',
      imageGeneration: 'Image Generation',
      other: 'Other',
    },
    providers: {
      custom: 'Custom',
    },
    action: {
      create: 'Create Model',
      edit: 'Edit Model',
    },
    modal: {
      delete: {
        title: 'Confirm Delete',
        content: 'Please confirm whether to delete this model.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      offline: {
        title: 'Offline Model',
        content: 'Please confirm whether to take this model offline from the model square.',
      },
      online: {
        title: 'Publish Model',
        content: 'Please confirm whether to publish this model to the model square.',
      },
    },
    message: {
      fetchFailed: 'Failed to fetch model list, please try again',
      fetchCatalogFailed: 'Failed to fetch related services',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed, please try again',
      offlineSuccess: 'Offline successfully',
      onlineSuccess: 'Publish successfully',
      publishSuccess: 'Publish successfully',
      publishFailed: 'Publish failed, please try again',
      operationFailed: 'Operation failed, please try again',
      createSuccess: 'Create successfully',
      createFailed: 'Create failed, please try again',
      updateSuccess: 'Update successfully',
      updateFailed: 'Update failed, please try again',
      fetchDetailFailed: 'Failed to fetch model detail',
      imageSizeExceeded: 'Image size cannot exceed 500KB, current size: {{size}}KB',
      addTagSuccess: 'Tag added successfully',
      addTagFailed: 'Failed to add tag',
      detailsRequired: 'Model details cannot be empty',
      uploadImage: 'Upload Image',
      fileTypeError: 'Unsupported file type',
      fileSizeExceeded: 'File size cannot exceed {{size}}MB',
      uploadFailed: 'Upload failed, please try again',
      uploadImageFailed: 'Image upload failed',
    },
  },
  statistics: {
    title: 'Usage Statistics',
    filters: {
      userAccount: 'User Account',
      apiKey: 'API Key',
      model: 'Model',
      statisticsPeriod: 'Statistics Period',
      allApiKeys: 'All API Keys',
      allModels: 'All Models',
      selectUserAccount: 'Please select user account',
      selectApiKey: 'Please select API Key',
      selectModel: 'Please select model',
      periodTooltip: 'Filter by completion time. Querying usage data over 30 days may take 5-10 seconds due to large data volume.',
    },
    actions: {
      reset: 'Reset',
      query: 'Query',
    },
    summary: {
      modelUsedCount: 'Total Models Used',
      callCount: 'Total API Calls',
      totalTokens: 'Total Tokens',
      inputTokens: 'Input Tokens',
      outputTokens: 'Output Tokens',
    },
    messages: {
      fetchFailed: 'Failed to fetch statistics data, please try again',
      loadApiKeysFailed: 'Failed to load API key list',
      loadModelsFailed: 'Failed to load model list',
      cappedToThreeMonths: 'Query time range has been limited to the last 3 months.',
      apiOnlyNote: 'Currently only statistics for API calls are included.',
    },
    charts: {
      trendTitle: 'Model Usage Trend',
      distributionTitle: 'Usage Distribution',
      noData: 'No Data',
      userDistribution: 'User Distribution',
      apiKeyDistribution: 'API Key Distribution',
      modelDistribution: 'Model Distribution',
      total: 'Total',
    },
    metrics: {
      requestCount: 'Request Count',
      totalTokens: 'Total Tokens',
      inputTokens: 'Input Tokens',
      outputTokens: 'Output Tokens',
    },
  },
  bills: {
    title: 'Transaction Bills',
  },
  gpuDashboard: {
    title: 'GPU Resource List',
    table: {
      zone: 'Available Zone',
      cluster: 'Cluster',
      ip: 'IP Address',
      hostname: 'Hostname',
      resourceGroup: 'Resource Group',
      gpuType: 'GPU Type',
      gpuTotal: 'GPU Total',
      gpuOccupied: 'GPU Occupied',
      gpuAvailable: 'GPU Available',
      cpuResource: 'CPU Resource',
      memoryResource: 'Memory Resource',
      cpuCore: 'Cores',
    },
    filter: {
      zone: 'Available Zone',
      zonePlaceholder: 'Please select available zone',
      cluster: 'Cluster',
      clusterPlaceholder: 'Please select cluster',
      query: 'Query',
      reset: 'Reset',
      export: 'Export Data',
    },
    statistic: {
      total: 'Total',
      occupied: 'Occupied',
      available: 'Available',
    },
    message: {
      loadStatsFailed: 'Failed to load statistics, please try again later',
    },
    pagination: {
      total: 'Total {{total}} items',
      itemsPerPage: 'items/page',
      jumpTo: 'Jump to',
      jumpToConfirm: 'Confirm',
      page: 'Page',
      prevPage: 'Previous Page',
      nextPage: 'Next Page',
    },
  },
  storageQuota: {
    title: 'Resource Quota',
    detail: 'Resource Quota Details',
    edit: 'Edit Resource Quota',
    create: 'Resource Quota',
  },
  fileStorage: {
    title: 'File Storage',
  },
  inspection: {
    title: 'System Inspection',
  },
}

export default translation
